/**
 * EmptyState component condiviso — sostituisce i "Nessun X trovato" anonimi
 * con un layout coerente: icona grande circolare, titolo, microcopy, CTA.
 *
 * Usato in projects, customers, materials, ceilings, suppliers, ecc.
 */
import React from 'react';
import { Card, CardContent } from '@/components/ui/card';

interface EmptyStateProps {
  icon: React.ReactNode;
  title: string;
  description?: string;
  /** CTA primaria (bottone, link, ecc.). */
  action?: React.ReactNode;
  /** Action secondario sotto, in font più piccolo. */
  secondaryAction?: React.ReactNode;
  /** Variante "card" wrappa in un Card, "inline" no (default: inline). */
  variant?: 'card' | 'inline';
  /** Colore dell'icona (default: text-primary/30). */
  iconColor?: string;
}

const EmptyState: React.FC<EmptyStateProps> = ({
  icon, title, description, action, secondaryAction, variant = 'inline', iconColor,
}) => {
  const content = (
    <div className="flex flex-col items-center justify-center text-center py-12 px-4">
      <div className={`mb-4 p-4 rounded-full bg-muted/50 ${iconColor ?? 'text-primary/40'}`}>
        <div className="h-12 w-12 flex items-center justify-center">{icon}</div>
      </div>
      <h3 className="text-lg font-semibold mb-1.5">{title}</h3>
      {description && (
        <p className="text-sm text-muted-foreground max-w-md mb-5">{description}</p>
      )}
      {action && <div>{action}</div>}
      {secondaryAction && (
        <div className="mt-2 text-xs text-muted-foreground">{secondaryAction}</div>
      )}
    </div>
  );

  if (variant === 'card') {
    return (
      <Card>
        <CardContent className="p-0">{content}</CardContent>
      </Card>
    );
  }
  return content;
};

export default EmptyState;
